const Utils = {
  removeUserDetail: () => {
    localStorage.removeItem("toggleStatus");

    localStorage.removeItem("userDetails");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userData");
  },
  setUserDetail: (data) => {
    localStorage.setItem("userDetails", JSON.stringify(data));
  },
  getUserDetail: () => {
    let userDetail = localStorage.getItem("userDetails");
    if (userDetail) {
      userDetail = JSON.parse(userDetail);
      return userDetail;
    } else {
      return null;
    }
  },
  getTagColor: (index) => {
    const colors = [
      "magenta",
      "volcano",
      "gold",
      "green",
      "orange",
      "cyan",
      "purple",
      "geekblue",
      "red",
    ];
    return colors[index % colors.length]; // rotate between the colors
  },
  getProfileData: () => {
    let userDetail = localStorage.getItem("userData");
    if (userDetail) {
      userDetail = JSON.parse(userDetail);
      return userDetail;
    } else {
      return null;
    }
  },
  converToDateMonthYear: (value) => {
    const preferredJoiningDate = value;
    let readableDate = "";
    if (preferredJoiningDate) {
      const date = new Date(preferredJoiningDate);
      const options = { year: "numeric", month: "short", day: "numeric" };
      readableDate = date.toLocaleDateString("en-US", options);
    }
    return readableDate;
  },
  toParams: (objectRef) => {
    var params = "";
    for (var key in objectRef) {
      if (objectRef[key] && typeof objectRef[key] == "object") {
        params +=
          key.toString() +
          "=" +
          encodeURIComponent(
            decodeURIComponent(
              encodeURIComponent(JSON.stringify(objectRef[key]))
            )
          ) +
          "&";
      } else {
        params +=
          key.toString() + "=" + encodeURIComponent(objectRef[key]) + "&";
      }
    }
    return params.slice(0, -1);
  },
};

export default Utils;
